import addOneLog from "features/panelManagement/logging/actions/set.addOneLog";
import batchOperations from "services/firebase/batchOperations";
import { AppThunk } from "services/redux/rootReducer";
import { Article } from "../../types/article";

const addManyArticles =
    (articles: Article[]): AppThunk =>
    async (dispatch) => {
        await batchOperations(async (batch, db, batchedArticles) => {
            batchedArticles.forEach((article) => {
                const docRef = db.collection("articles").doc();

                const currentTimestamp = Date.now();
                const uploadedArticle: Article = {
                    ...article,
                    id: docRef.id,
                    properties: {
                        ...article.properties,
                        creationTimestamp: currentTimestamp,
                        updateTimestamp: currentTimestamp,
                    },
                };

                batch.set(docRef, uploadedArticle);
            });
        }, articles);

        dispatch(
            addOneLog({
                eventInfo: {
                    description: `Added multiple article(s) with names(s) ${articles
                        .map((article) => article.properties.name?.en)
                        .join(", ")}`,
                },
            })
        );

        return;
    };

export default addManyArticles;
